import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { 
	getAnimalsStatusChart
} from "../../../../redux/dashboard/dashboardState";
import CardItem from "components/card/CardItem";
import LineChart from "components/charts/LineChart";
import { MdBarChart } from "react-icons/md";
import ModalSearchFilter from "components/search/ModalSearchFilter";

const AnimalsStatusChart = ({getChartData, graphData, requesting, success, error, filters, ...props}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);

  useEffect(() => {
      getChartData(filters);
  }, [getChartData]);

  const isLoading = requesting && !success;
  const hasError = error && !requesting;

  const applyFilter = (filters) => {
    closeModal();
    getChartData(filters);
  }

  const resetFilter = () => {
    closeModal();
    getChartData(null);
  }
  
  return (
    <CardItem extra="pb-7 p-[20px]"
      icon={<MdBarChart className="h-6 w-6 text-theme-500 dark:text-theme-400"/>}
      title={"Animal's Condition Trends"}
      cardMenu={
        <button 
          onClick={openModal}
          className="card-menu-button">
        Filter
        </button>
      }
    >
    
      <div className="h-[340px] w-full pt-4 pb-0">
      {isLoading ? (
          <p className="text-gray-500 text-sm">Loading chart...</p>
        ) : hasError ? (
          <p className="text-red-500 text-sm">Failed to load chart data.</p>
        ) : (
          <LineChart
            series={graphData.series}
            options={graphData.options}
          />
        )}
      </div>

      <ModalSearchFilter 
        className="form-column-2" 
        isModalVisible={isModalVisible}
        closeModal={closeModal}
        filterHandler={applyFilter}
        resetHandler={resetFilter}
        title="Apply Filters"
        withDateRange={false}/>
    </CardItem>
  );
};

const mapStateToProps = (state) => ({
    requesting: state.dashboard.animalsStatusChart?.requesting,
    success: state.dashboard.animalsStatusChart?.success,
    error: state.dashboard.animalsStatusChart?.error,
    graphData: state.dashboard.animalsStatusChart.chartData,
    filters: state.dashboard.animalsStatusChart?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  getChartData: (filters) => dispatch(getAnimalsStatusChart(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnimalsStatusChart);
